import { PatientGroupEffect } from '@dreryk/egabinet-patient-frontend-api';

import { PredefinedPatientGroupsUpdateFormBean } from './PredefinedPatientGroupsUpdateForm.types';

export const FIELD_TO_EFFECT: Record<keyof PredefinedPatientGroupsUpdateFormBean, PatientGroupEffect> = {
   patientPortal: 'BLOCK_CREATING_APPOINTMENTS_FROM_PATIENT_PORTAL',
};
